

































import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Radio from "@/components/Atoms/Forms/Radio/index.vue";

export interface Data {}

export interface Computed {}
export interface Props {
  compareCompanyNames: string[];
  selectedYear: number;
  latestYear: number;
}
export interface Methods {
  handleChangeSelectedYear: (value: string) => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompareCompanyChartLegend",
  components: {
    Heading,
    Radio
  },
  props: {
    compareCompanyNames: {
      type: Array as PropType<Props["compareCompanyNames"]>,
      required: true
    },
    selectedYear: {
      type: Number as PropType<Props["selectedYear"]>,
      required: true
    },
    latestYear: {
      type: Number as PropType<Props["latestYear"]>,
      required: true
    }
  },
  methods: {
    handleChangeSelectedYear(value) {
      this.$emit("changeSelectedYear", value);
    }
  }
});
